module.exports = __webpack_public_path__ + "img/cp-outlined-fish-2.3065c547.svg";